<template>

  <div  clearfix class="clearfix main_center">


    <div class="content">
      <!--Video-->
      <div class="streamPlayerWrapper" :style="{height:videoHeight + 'px'}">
        <streamPlayer
                ref="streamPlayerRef"
                videoCode="flv"
                :videoUrl.sync="videoUrl"
                :height="videoHeight.toString()"
                @cutAndUploadSuccess="addTableData">
        </streamPlayer>
        <placeAndEquipment
                ref="placeAndEquipmentRef"
                :showSrcSwitch="true"
                roomType="2"
                :currentVideo.sync="currentVideo"
                :videoSwitchData.sync="videoSrcData"
                @switchCurrentVideo="switchVideoUrl"></placeAndEquipment>

      </div>
      <!--form-->


        <el-form ref="form" :model="form"  :rules="roles" style="width:calc(100% - 252px);float: left;margin-top: 12px"  label-width="120px" class="form">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="见证记录：" prop='witnessContent' >
                    <el-input type="textarea" :rows="5" :disabled="disableEdit" v-model="form.witnessContent" maxlength="600"  show-word-limit ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="11">
                  <el-form-item label="见证人：" prop='witnessUserId' >
                    <el-input   v-model="form.witnessUserName" disabled ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" :offset="1">
                  <el-form-item label="开标完成时间：" prop="bidopenEtime" :error="bidopenEtimeerror">
                    <el-date-picker
                        v-model="form.bidopenEtime"
                        :disabled="disableEdit"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择时间">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="11">
                  <el-form-item label="所属交易中心：" prop='tradeId'>
                    <el-select v-model="form.tradeId"  style="width:100%;">
                      <el-option v-for="(item) in transactionCenterList" :key="item.id" :label="item.orgName" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item label="关键记录："  >
                    <el-button size="mini" :disabled="disableEdit" @click="cutScreenAndUpload" >+   添加</el-button>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row >
                <el-col :span="24"  >
                  <el-table
                      :data="tableDataDetail"
                      border
                      v-loading="keyListLoading"
                      @cell-click="cellClick"
                      style="width:calc(100% - 120px);margin-left: 120px">
                    <el-table-column
                        header-align="center"
                        label="序号"
                        width="50"
                        type="index"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        header-align="center"
                        label="操作"
                        width="80"
                        align="center">
                      <template slot-scope="scope">
                        <el-button @click="removeTableData(scope.row,scope.$index)" :disabled="disableEdit" type="text"  size="small">移除</el-button>
                      </template>
                    </el-table-column>
                    <el-table-column
                            prop="recordTime"
                            header-align="center"
                            label="时间"
                            width="180"
                            align="center">
                      <template scope="scope">
                        <span style="margin-left: 10px" >{{ formatDate( scope.row.recordTime,'HH:mm:ss')}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="快照" align="center" width='100'>
                      <template slot-scope="scope">
                        <img :src="scope.row.screenshotUrl" @click="showImgDialog(scope.row.screenshotUrl)" v-if="scope.row.screenshotUrl" class="thumbnail" alt="">
                      </template>
                    </el-table-column>
                    <el-table-column
                        prop="remark"
                        header-align="center"
                        label="备注">
                      <template scope="scope">
                        <span style="margin-left: 10px" v-show="!scope.row.seen || disableEdit">{{ scope.row.remark }}</span>
                        <el-input v-model="scope.row.remark" type="textarea"  @blur="loseFcous(scope.row,this)" v-show="scope.row.seen && !disableEdit" maxlength="200" show-word-limit > </el-input>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>

              <div style="float: right;margin: 10px 0px">
                <el-button type="primary" :disabled="disableEdit" @click="save(-1)">保存</el-button>
                <el-button type="primary" :disabled="disableEdit" @click="commit()">提交</el-button>
              </div>

        </el-form>
        <div class="baseInfo">
          <p><span class="label">项目名称：</span> <span>{{ project.projectName}}</span></p>
          <p><span class="label">项目编号：</span> <span>{{ project.projectCode}}</span></p>
          <p><span class="label">开标室：</span> <span>{{ project.bidOpenRooms}}</span></p>
          <p><span class="label">招标人：</span> <span>{{ project.tendererName}}</span></p>
          <p><span class="label">联系人：</span> <span>{{ project.tendererLinkMan}}</span></p>
          <p><span class="label">联系电话：</span> <span>{{ project.linkPhone}}</span></p>
          <p><span class="label">招标代理：</span> <span>{{ project.tenderAgencyName}}</span></p>
        </div>
        <div class="enterView">
            <el-button type="primary" @click="onClickJumpToBidOpenSystem">进入不见面开标系统</el-button>
        </div>
      <div style="clear: both"></div>
    </div>
    <el-dialog :visible.sync="imgDialogVisible" width="100%" height="100%" @opened="dialogOpen">
      <img :src="dialogImageUrl" alt="" @contextmenu.prevent=""  class="viewImg">
    </el-dialog>
  </div>
</template>



<script>
  import {mapState} from "vuex";
  import streamPlayer from "@/components/videoPlayer/streamPlayer";
  import placeAndEquipment from "@/components/videoPlayer/placeAndEquipment";
  import {validateDate} from "@/utils/validate";
  import {tabsCloseCurrentHandle} from '@/utils/routeTab';
  import {isIEBrowser, scrollToTop} from '@/utils/index';

  export default {
    components: {
      streamPlayer,
      placeAndEquipment,
    },
  data(){
    return{
      projectListDialog :false,
      bidListDialog: false,
      keyIframeTime:'', // 关键帧截取时间
      roomCode:"",
      isIE:false,
      imgDialogVisible:false,
      dialogImageUrl:"",
      currentVideo:{},
      videoSrcData:[],
      videoUrl:"",
      videoUrl1:'https://ggfw.ggzy.hebi.gov.cn/dgwitness/play/hdl/live/cf4a74faa2d2d75260d0172ea775c4cf.flv',
      videoHeight:750,
      displayName:'',  //展示在页面的项目名或者标段名
      dateRange:[], //交易起止时间
      roles: {
        witnessContent: [{required: true, message: '请填写见证记录', trigger: 'blur'}],
        bidopenEtime: [{ required: true,type: 'date', validator: validateDate, message: '请选择日期', trigger: 'change' }],
      },
      errorData:{},
      form:{    //见证数据
        id: "",          //见证数据ID
        bidopenTime: "", //开标时间
        businessId: "",  //关联的项目ID
        businessexId: "",  //关联的标段ID
        createTime: "",  //创建时间
        createUser: "",  //创建人
        dataType: "1",    //见证类型     1专家抽取见证 2开标见证 3评标见证
        delFlag: false,
        detailList: [], //见证明细数据
        evalEtime: "",  //评标结束时间
        evalStime: "",  //评标开始时间
        field1: "",     //扩展字段1
        field2: "",     //扩展字段2
        field3: "",     //扩展字段3
        year:"", //年份
        fileTypeDictCode: "",
        fileTypeMap: {},
        historyid: "",  //-1:暂存   0:已生效
        remark: "",     //备注
        updateTime: "", //更新时间
        updateUser: "", //更新用户
        videoEtime: "", //视频结束时间
        videoStime: "", //视频开始时间
        witnessContent: "",
        witnessUserId: "",
        witnessUserName:'',
        bidopenEtime:"",//开标完成时间
        dataSource:"",
        tradeId: '',


        bid:{ //标段数据
          id:'',//标段ID
          bidOpenRoomName:""
        },
      },
      project: {  //项目数据
        id: "",
        bidOpenRoomName:"",
        projectCode: "",   //项目编号
        projectName: "",   //项目名称f
        tenderAgencyName: "", //招标代理机构名称
        tendererName:"" ,  //招标人名称
        tendereeConnector:"",//招标人联系人
        tendereeContact:"" //招标人联系方式
      },
      tableDataDetail: [],  //明细列表
      keyListLoading:false,
      tableDataProject:[],
      tableDataBid:[],
      transactionCenterList: [],

    }


  },
  computed:{

    ...mapState({
      stateData:state=>state.user
    }),
    disableEdit:function () {
      return this.form.historyid == 0?true:false;
    },
    bidopenEtimeerror:function () {
      return this.errorData.bidopenEtime;
    },
  },
  activated(){
    this.form.businessexId = (this.$route.query && this.$route.query.id ) || '' ;
    this.form.witnessUserName = this.stateData.displayName ;
    this.roomCode =  (this.$route.query && this.$route.query.roomCode ) || '' ;
    this.form.dataSource =  (this.$route.query && this.$route.query.dataSource ) || '' ;
    // 获取见证记录数据
    this.getDataById();
    // 获取见证基本数据
    this.getBaseInfo()
    // 获取视频源
    this.getVideoUrlList(this.form.businessexId,'bid',2)

    this.$nextTick(() => {
      if(this.$refs.streamPlayerRef){
        this.$refs.streamPlayerRef.play(); // 播放
      }
    })


  },

    deactivated() {
      if(this.$refs.streamPlayerRef){
        this.$refs.streamPlayerRef.pause();  // 暂停
      }
    },
    created() {
      this.isIE = isIEBrowser();
      this.transactionCenterList = JSON.parse(sessionStorage.getItem("transactionCenterList"));
    },
    mounted() {
      this.videoHeight = document.documentElement.clientHeight<600?600:(document.documentElement.clientHeight-125+ (this.isIE?-80:0));
    },
    methods:{
        // 点击进入不见面开标系统
        onClickJumpToBidOpenSystem() {
            const token = this.$cookie.get('access_token')
            window.open(`${process.env.VUE_APP_bidOpenUrl}?token=${token}`, 'bidOpenWindow' );
        },

    switchVideoUrl(video){

      this.currentVideo = video;
      this.videoUrl = this.currentVideo.playUrl?this.currentVideo.playUrl:'';
      this.$nextTick(()=>{
        this.getKeyIframeList()
      })
    },

    cutScreenAndUpload(){

      this.keyIframeTime =  this.formatDate( new Date(),'yyyy-MM-dd HH:mm:ss')

      if(this.form.id){
        const _this = this;
        if(this.isIE){
          scrollToTop(function(){
            _this.$refs.streamPlayerRef.cutVideoScreen();
          })
        }else{
          this.$refs.streamPlayerRef.cutVideoScreen();
        }
      }else{
        this.$message({
          type:'error',
          message:"请先保存见证记录信息"
        })
      }

    },

      dialogOpen(){

        this.$nextTick(() => {
          this.iframeInsert(this.$el);
        });

      },
    dialogClose() {
      this.dialogImageUrl = "";
      this.imgDialogVisible = false;
    },
    // 图片放大弹窗
    showImgDialog(filePath){
      this.dialogImageUrl=filePath;
      this.imgDialogVisible = true;
      this.$nextTick(()=>{
        this.iframeInsert(this.$el);
      })
    },

    getKeyIframeList() { // 获取列表数据


      if(this.form.id && this.currentVideo.id){
        this.keyListLoading = true;
        this.$http.get(`/trading/tradingWitDetails/getByWitnessIdAndDeviceCode?witnessId=${this.form.id}&deviceCode=${this.currentVideo.id}`,)
          .then(res=>{
            this.keyListLoading = false;
            if(res.data.code =="1"){
              this.tableDataDetail = res.data.data;
              // this.tableDataDetail.forEach((item)=>{
              //   item.screenshotUrl = this.$http.adornUrl(item.screenshotUrl)
              // })
            }else{
              this.tableDataDetail = [];
            }

          })
      }

    },

    getVideoUrlList(id,bizType,roomType){

      // 查询场地及场地的摄像头
      this.$http.get(`/tradding/traddingwitness/getFieldsAndDevice?code=${id}&roomType=${roomType}&bizType=${bizType}`).then(res=>{
        if(res.data.code==='1'){

          this.videoSrcData = res.data.data;

          const that =this;
          this.videoSrcData.forEach((item,index)=>{
            if( (item.fieldInfo.code == that.roomCode) && item.devices && item.devices[0]){
              that.currentVideo = JSON.parse(JSON.stringify(item.devices[0]))
            }
          })
          if(JSON.stringify(this.currentVideo) == '{}' && this.videoSrcData[0] && this.videoSrcData[0].devices && this.videoSrcData[0].devices[0]){
            this.currentVideo=JSON.parse(JSON.stringify(this.videoSrcData[0].devices[0]));
          }

          this.$refs.placeAndEquipmentRef.setCurrentVideo(this.currentVideo);
          this.videoUrl = this.currentVideo.playUrl?this.currentVideo.playUrl:'';
          this.$nextTick(()=>{
            this.getKeyIframeList()
          })



        }else{
          this.videoSrcData = [];
          this.videoUrl='';
        }
      })
    },

    //解析时间范围
    evalDate() {
       this.form.evalStime=this.dateRange[0]?this.dateRange[0]:"";
       this.form.evalEtime=this.dateRange[1]?this.dateRange[1]:"";
    },
    //反解析时间范围
    unEvalDate() {
      this.dateRange = [this.form.evalStime, this.form.evalEtime];
    },
    

    loseFcous(row, index) {
      row.seen=false;
    },
    cellClick(row,column, cell, event) {
      if(column.property == 'remark') {
        row.seen = true;
        //延时加载focus
        setTimeout(function () {
          // $(cell.lastChild).find("textarea").focus();
          // 上面代码find 在IE报错 "无法重新定义不可配置的属性“find”" 目前不知什么原因，只能用下面原生方法代替
          cell.lastChild.lastChild.firstElementChild.focus();
        }, 100);
      }
    },

    //新增一条表格数据
    addTableData(screenshotUrl){



      if(screenshotUrl){

        const keyIframe = {
          seen:false,
          date: '',
          parentId:this.form.id,
          recordTime: this.keyIframeTime || this.formatDate( new Date(),'yyyy-MM-dd HH:mm:ss') ,
          screenshotUrl:screenshotUrl,
          deviceCode:this.currentVideo.id,
          dataType:2, // 1 专家抽取 2 开标见证 3 评标
          remark: ''
        }

        this.$http.post('/trading/tradingWitDetails/save',keyIframe).then(res=>{
          if(res.data.code == '1'){
            this.tableDataDetail.push(res.data.data);
          }else{
            this.$message({
              type:'error',
              message:res.data.msg
            })
          }
        })

      }

    },

    //移除表格的数据
    removeTableData(row,index) {

      this.$confirm(`确定要删除该数据?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/trading/tradingWitDetails/delete' ,{
          id: row.id,
        }).then(res => {
          if (res.data.code == '1') {
            this.$message({
              type: 'success',
              message: res.data.msg
            })
            this.getKeyIframeList();

          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      })


    },

    backBtn(){ //返回
      tabsCloseCurrentHandle();
      this.clearData()
      this.$router.push({
        name:'openBidAndEstimateWitness_list'
      })

    },

    getBaseInfo(){

      //获取开评标见证数据项目详情
      if(this.form.businessexId != ""){
        this.$http.get(`/tradding/traddingwitness/sideInfo?bidCode=${this.form.businessexId}&roomType=3&dataSource=${this.form.dataSource}`).then(res=>{
          if(res.data.code == '1'){
            const data = res.data.data;
            this.form.businessId = data.projectCode || '';
            this.form.bidopenTime = data.bidopenTime || '';
            this.project = data || {}
          }
        })
      }

    },

    getDataById(){

      //详情
      if(this.form.businessexId != ""){
        this.$http.get('/tradding/traddingwitness/getOpenEstimateWitness?id='+this.form.businessexId+'&dataType=2').then(res=>{
          if(res.data.code == '1'){
            const data = res.data.data;
            this.form={...data};
            this.form.witnessUserName = this.form.witnessUserName || this.stateData.displayName ;


          }else{

            // 无见证记录数据，重置表单数据
            this.form.id = '';
            this.form.witnessContent = '';
            this.form.historyid = -1;
            this.form.detailList=[];
            this.tableDataDetail = [];
            this.form.witnessUserName = this.stateData.displayName ;


          }
        })
      }else {
        this.$router.push({
          name:'openBidAndEstimateWitness_beginList'
        })
      }

    },


    commit(){

      this.$confirm(`提交后无法再对该项目实时见证，确认提交?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.save(0)

      }).catch(() => {});


    },

    checkCutVideoTime(){

      let keyListLength =this.tableDataDetail.length;

      if(keyListLength>0){
        // let  firstKeyTime = this.tableDataDetail[0] && this.tableDataDetail[0].recordTime || '' ;
        let  lastKeyTime = this.tableDataDetail[keyListLength-1] && this.tableDataDetail[keyListLength-1].recordTime || '' ;
        if(lastKeyTime && this.form.bidopenEtime && (new Date(this.form.bidopenEtime.replace(/-/g,"/")).getTime() < new Date(lastKeyTime.replace(/-/g,"/"))) ){
          this.errorData = {
            evalEtime:"日期选择有误"
          }
          this.$message({
            type:'error',
            message:"有关键帧不在开标时间范围内，请修改后提交！"
          })
          return false;
        }
      }
      this.errorData.bidopenEtime='';
      return true;

      // this.form.videoStime=this.timeRange[0]?this.timeRange[0]:(this.formatDate( new Date(),'yyyy-MM-dd') + ' 08:00:00');
      // this.form.videoEtime=this.timeRange[1]?this.timeRange[1]:(this.formatDate( new Date(),'yyyy-MM-dd') + ' 20:00:00');

    },

    save(status){ //新增&保存

      let checkVideoCutTime = this.checkCutVideoTime();
      if(!checkVideoCutTime){
        return
      }

      this.$refs['form'].validate((valid) => {
        if (valid) {
          //表格数据转储到detailList
          this.form.detailList = this.tableDataDetail;
          this.form.dataType = 2; //开标见证
          this.form.dataGroup= 2;
          this.form.historyid=status; //状态为保存
          this.form.witnessUserId = this.stateData.userinfo.userId;
          if (status == -1) {
            this.$http.post('/tradding/traddingwitness/save',this.form).then(res=>{
              if(res.data.code == '1'){
                this.form={...res.data.data}
                this.$message({
                  type:'success',
                  message:res.data.msg,
                })

              }else{
                this.$message({
                  type:'error',
                  message:res.data.msg
                })
              }
            });
          }else{
            this.$http.post('/tradding/traddingwitness/submit',this.form).then(res=>{
              if(res.data.code == '1'){
                this.form={...res.data.data}
                this.$message({
                  type:'success',
                  message:res.data.msg,
                })

              }else{
                this.$message({
                  type:'error',
                  message:res.data.msg
                })
              }
            });
          }


        }
      })
    },







  },


}
</script>

<style lang="less" scoped>

  .viewImg{
    height: 100%;
    display: block;
    margin: 0 auto;
  }

  .main_center{

    /deep/ .el-dialog__header{
      border-bottom: 0;
    }
    /deep/ .el-dialog__body{
      padding: 0 10px 20px 10px;
    }

    .streamPlayerWrapper{
      width: 100%;
      height:750px;
      display: block;
      text-align: center;
      position: relative;
      z-index: 10;
    }


  }


.thumbnail{
  width: 50px;
  height: 50px;
}


  .baseInfo{
    padding:6px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    height: 408px;
    width: 242px;
    float: right;
    margin:12px 0px;
    p{
      line-height: 20px;
      span.label {
        width: 70px;
        font-weight: 600;
        display: inline-block;
        text-align: right;
        vertical-align: top;
      }
      span:last-child{
        display: inline-block;
        vertical-align: top;
        text-align: left;
        width: 153px;
      }
    }

  }
  .enterView{
      display: flex;
      justify-content: center;
      width: 242px;
      float: right;
      margin: 12px 0;
  }
</style>
